import React, { memo } from "react";
import { trackEvent } from "@leafly-com/web-utils";

import { Deal } from "custom-types/Deals";

import DealCard from "components/botanic//DealCard";
import Carousel from "components/botanic/Carousel";
import TrackImpression from "components/TrackImpression";

type Props = {
  deals: Deal[];
  page: string;
  title: string;
};

export const DealsCarousel = ({ deals, page, title }: Props): JSX.Element => {
  return (
    <Carousel
      title={title}
      className="h-full"
      seeMoreHref={deals.length >= 5 ? "/deals" : undefined}
      seeMoreText="more deals"
      seeMoreOnClick={() => {
        trackEvent("Deals Carousel", "Click", `${page} Shop All Deals`);
      }}
    >
      {deals.map((deal, i) => {
        deal.dealUrl = deal.link;
        const eventCategory = "Deals Carousel Card";
        const eventLabel = `${page} Deals Slot ${i + 1}: ${
          deal.dispensary.name
        }`;
        const customDimensions = {
          "Deal Id": deal.id,
          "Dispensary Id": deal.dispensary.id,
        };
        return (
          <TrackImpression
            key={`deals-${deal.id}`}
            category={eventCategory}
            label={eventLabel}
            customDimensions={customDimensions}
            className="h-full"
          >
            <DealCard
              onClick={() => {
                trackEvent(
                  eventCategory,
                  "Click",
                  eventLabel,
                  customDimensions,
                );
              }}
              className="h-full w-full rounded shadow-low overflow-hidden"
              deal={deal}
            />
          </TrackImpression>
        );
      })}
    </Carousel>
  );
};

export default memo(DealsCarousel);
